export const subCollectionList = [
  { value: 'A00105' },
  { value: 'A00020' },
  { value: 'A00161' },
  { value: 'A00018' },
  { value: 'A00177' },
  { value: 'A00076' },
]
